// extracted by mini-css-extract-plugin
export default {"container":"Walls_container__GaLXr","productListContainer":"Walls_productListContainer__-0ui7","productGrid":"Walls_productGrid__cG8OP"};